import { z } from 'zod';

export const ASPECT_RATIOS = ['1:1', '4:5', '9:16', '16:9'] as const;
export const AspectRatioSchema = z.enum(ASPECT_RATIOS);
export type AspectRatio = z.infer<typeof AspectRatioSchema>;

export function aspectRatioToDimensions(
  ratio: AspectRatio,
  longestSidePx: number,
): { width: number; height: number } {
  const map = {
    '1:1': [1, 1],
    '4:5': [0.8, 1],
    '9:16': [0.5625, 1],
    '16:9': [1, 0.5625],
  } as const satisfies Record<AspectRatio, readonly [number, number]>;
  const [w, h] = map[ratio];
  const width = w <= h ? Math.floor((longestSidePx * w) / 64) * 64 : longestSidePx;
  const height = w <= h ? longestSidePx : Math.floor((longestSidePx * h) / 64) * 64;
  return { width, height };
}
